<ngx-spinner type="line-scale-party">
    <h3>Loading...</h3>
</ngx-spinner>

<app-nav style="position: relative; z-index: 10;"></app-nav>
<div class="container" style="margin-top: 100px; position: relative; z-index: 0;">
    
    <router-outlet></router-outlet>

</div>
